<template>
    <div class="page-title">
        <h1>{{ main }}</h1>
        <h2>{{ sub }}</h2>
        <hr>
    </div>
</template>

<script>
export default {
    name: 'PageTitle',
    props: ['main', 'sub']
}
</script>

<style>
    .page-title h1 {
        font-size: 2rem;
        margin: 0px;
        margin-left: 20px;
        color: #444444;
    }

    .page-title h2 {
        color: #777;
        margin-top: 5px;
        margin-left: 30px;
        font-size: 1.2rem;
    }
</style>
